import { attr, many } from 'redux-orm';
import { BaseModel } from './base';
import { OrganizationType } from '../const/enum';

export interface IOrganization {
    id: string;
    name: string;
    members: string[];
    logoUrl?: string;
    actionStats: string[];
    tagStats: string[];
    orgType: OrganizationType;
    /** MaxSeats === null when EnhancedBillingFeature turned on. */
    maxSeats?: number;
    seatsAllocated: number;
    /**
     * Whether the organization is in free trial mode
     */
    isFreeTrial: boolean;
    trialFlowName?: string | null;
    tenantCreatedAt: string;
    tenantId: string;
    parentTenantId: string;
    parentTenantName: string;
    /** Optional Stripe customer id associated with organization */
    stripeCustomerId?: string;
    /** Optional Stripe subscription id associated with organization */
    stripeSubscriptionId?: string;
}

export class Organization extends BaseModel<typeof Organization, IOrganization> {
    static modelName = 'Organization';
    static fields = {
        id: attr(),
        name: attr(),
        members: many('OrganizationMember'),
        logoUrl: attr(),
        actionStats: attr(),
        tagStats: attr(),
        orgType: attr(),
        /** MaxSeats === null when EnhancedBillingFeature turned on. */
        maxSeats: attr(),
        seatsAllocated: attr(),
        isFreeTrial: attr(),
        trialFlowName: attr(),
        instanceId: attr(),
        tenantCreatedAt: attr(),
        tenantId: attr(),
        parentTenantId: attr(),
        parentTenantName: attr(),
        stripeCustomerId: attr(),
        stripeSubscriptionId: attr(),
    };
}
